<script setup lang="ts">
import { heroBanner } from '~/data/pages/banks/mocks'
import { WidgetBreadcrumbs } from '~/components/widget/breadcrumbs'
import { WidgetBanksPageListMeiliSearch } from '~/components/widget/banks-page'
import { WidgetCustomerCare } from '~/components/widget/customer-care'
import { WidgetSidebarRates } from '~/components/widget/sidebar-rates'
import { WidgetSeoContent, WidgetSeoHeroBanner } from '~/components/widget/seo'
import { WidgetReviveAd } from '~/components/widget/revive-ad'
import { WidgetFaqList } from '~/components/widget/faq-list'
import { WidgetBankingStatsCta } from '~/components/widget/banking-statistics'
import type { IBanksQueryParams } from '~/components/entity/bank/item'

const { t } = useI18n()
const breadcrumbs = [{ title: t('common.banks_of_kyrgyzstan'), url: '/banks' }]
const { pathWithoutLocale } = useLocalizedPath()

const banksListQueryParams = reactive<IBanksQueryParams>({
  per_page: '30'
})
</script>

<template>
  <Main>
    <Container>
      <WidgetBreadcrumbs :links="breadcrumbs" />
      <ContentLayout>
        <template #right-sidebar>
          <aside v-if="!$device.isMobile">
            <WidgetReviveAd zoneid="27" class="overflow-hidden rounded-lg" />
            <SidebarBlock variant="white" :heading-text="t('common.exchange_rates')">
              <WidgetSidebarRates />
            </SidebarBlock>
            <WidgetBankingStatsCta />
            <WidgetCustomerCare />
          </aside>
        </template>
        <div class="space-y-5">
          <WidgetSeoHeroBanner
            :heading="$t(heroBanner.heading)"
            :text="$t(heroBanner.text)"
            :image="heroBanner.image"
            illustration="banks"
            backdrop="dots"
          />

          <WidgetReviveAd zoneid="39" class="overflow-hidden rounded-lg" />

          <WidgetBanksPageListMeiliSearch :query-params="banksListQueryParams" />

          <WidgetCustomerCare v-if="$device.isMobile" />
          <WidgetSeoContent position="bottom" />
          <WidgetFaqList
            :query-params="{
              'filter[faqable_url]': pathWithoutLocale
            }"
          />
        </div>
      </ContentLayout>
    </Container>
  </Main>
</template>
